import React from 'react';
import MuiPhoneNumber from 'material-ui-phone-number';
import { makeStyles } from '@material-ui/core';

import { FieldWrap, FieldMessages, FieldLabel, FieldError } from '../common';
import colors from '@theme/colors';
import FieldRequiredLabel from '@components/Form/CountrySelect/FieldRequiredLabel';

const useStyles = makeStyles(() => ({
  phoneNumberInput: {
    display: 'block',
    fontFamily: 'GTAmerica',
    width: '100%',
    height: '56px',
    appearance: 'none',
    fontSize: '14px',
    letterSpacing: '0.5px',
    boxShadow: 'none',
    borderRadius: '0px',
    padding: '0 25px',
    color: colors['charcoal'],
    backgroundColor: colors['white'],
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&::placeholder': {
      color: colors['charcoal'],
      opacity: 0.54,
    },
    '&::-ms-clear': {
      width: 0,
      height: 0,
    },
  },
}));
const PhoneNumberInput = ({
  id,
  field,
  name,
  label,
  touched,
  register,
  errors,
  required,
  dark = 'false',
  ...rest
}) => {
  const styles = useStyles();

  return (
    <FieldWrap>
      <FieldMessages>
        <FieldLabel htmlFor={id} dark={!!dark}>
          {label}
          {required && <FieldRequiredLabel />}
        </FieldLabel>
        {errors && errors[field.name] && (
          <FieldError>{touched && errors[field.name]}</FieldError>
        )}
      </FieldMessages>
      <MuiPhoneNumber
        id={id}
        name={name}
        type="tel"
        fullWidth={true}
        variant={'standard'}
        defaultCountry={'nl'}
        disableAreaCodes={true}
        className={styles.phoneNumberInput}
        {...field}
        error={!!(errors && errors[field.name])}
        style={{ flexDirection: 'row' }}
        InputProps={{ disableUnderline: true }}
        {...rest}
      />
    </FieldWrap>
  );
};

export default PhoneNumberInput;
